module.exports = __webpack_public_path__ + "img/LoPresti.b77f59cf.png";